export default "__VITE_PUBLIC_ASSET__5d2a446b__"